import React from 'react';

const FullProjectDescription = () => {
  return (
    <div className="min-h-screen bg-[#f6f8fa] text-gray-800 px-6 py-10 font-sans">
      <div className="max-w-3xl mx-auto bg-white border border-gray-200 rounded-lg p-8 shadow-sm">
        <h1 className="text-3xl font-bold mb-4">📂 Project Title</h1>

        <p className="mb-4">
          A full-stack web application built using modern technologies to demonstrate <strong>scalability</strong>, <strong>security</strong>, and <strong>great UI/UX</strong>.
        </p>

        <hr className="my-6 border-gray-300" />

        <h2 className="text-2xl font-semibold mb-2">🚀 Features</h2>
        <ul className="list-disc list-inside mb-6 space-y-1">
          <li>User authentication with AWS Cognito</li>
          <li>JWT-based secure APIs</li>
          <li>Responsive UI with Tailwind CSS</li>
          <li>PhonePe payment integration</li>
          <li>Automated notifications and invoice generation</li>
        </ul>

        <h2 className="text-2xl font-semibold mb-2">🧠 Tech Stack</h2>
        <ul className="list-disc list-inside mb-6 space-y-1">
          <li><strong>Frontend:</strong> React, Axios, Tailwind CSS</li>
          <li><strong>Backend:</strong> Spring Boot, Java, JWT</li>
          <li><strong>Database:</strong> MySQL</li>
          <li><strong>Hosting:</strong> AWS EC2 / S3 / Amplify</li>
        </ul>

        <h2 className="text-2xl font-semibold mb-2">📁 Folder Structure</h2>
        <pre className="bg-gray-100 p-4 rounded-md text-sm overflow-x-auto mb-6">
<code>
{`
/src
  ├── components
  ├── pages
  ├── services
  └── App.js
`}
</code>
        </pre>

        <h2 className="text-2xl font-semibold mb-2">📸 Screenshots</h2>
        <p className="mb-4 italic">[Add image links or screenshots here]</p>

        <h2 className="text-2xl font-semibold mb-2">📝 How to Use</h2>
        <pre className="bg-gray-100 p-4 rounded-md text-sm overflow-x-auto mb-6">
<code>
{`
# Clone the repository
git clone https://github.com/your-username/project-name

# Install dependencies
npm install

# Run the app
npm start
`}
</code>
        </pre>

        <div className="mt-10">
          <a
            href="https://your-live-demo-link.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg text-lg font-medium shadow hover:bg-blue-700 transition"
          >
            🚀 View Live Project
          </a>
        </div>
      </div>
    </div>
  );
};

export default FullProjectDescription;
